import { IconButtonProps, Popover } from "@mui/material";
import { usePopoverActions } from "app/hooks/popover/usePopoverActions";
import { useCallback, useState } from "react";

import { NotificationIcon } from "./components/NotificationIcon";
import { NotificationPopoverContent } from "./components/NotificationPopoverContent";
import { _notifications } from "./data";
import { Notification } from "./entity";

export function NotificationsPopover(props: IconButtonProps) {
  const [notifications, setNotifications] =
    useState<Notification[]>(_notifications);

  const totalUnRead = notifications.filter(
    (item) => item.isUnRead === true,
  ).length;

  const { closePopover, openPopover, popoverElementAnchor } =
    usePopoverActions();

  const markAllAsRead = useCallback(() => {
    const updatedNotifications = notifications.map((notification) => ({
      ...notification,
      isUnRead: false,
    }));

    setNotifications(updatedNotifications);
  }, [notifications]);

  return (
    <>
      <NotificationIcon
        isPopoverOpened={!!popoverElementAnchor}
        numberOfUnreadNotifications={totalUnRead}
        onClick={openPopover}
        {...props}
      />

      <Popover
        anchorEl={popoverElementAnchor}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        onClose={closePopover}
        open={!!popoverElementAnchor}
        slotProps={{
          paper: {
            sx: {
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
              width: 360,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
      >
        <NotificationPopoverContent
          markAllAsRead={markAllAsRead}
          notifications={notifications}
          totalUnRead={totalUnRead}
        />
      </Popover>
    </>
  );
}
